module.exports = __webpack_public_path__ + "img/usp_icon2.87c036c3.svg";